import React, { useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

import { useBonusesContext } from 'src/components/BonusesProvider';

import PaymentMethodItem from './PaymentMethodItem';

const DepositPaymentMethodsDropdown = ({
  onMethodChange,
  paymentMethod,
  paymentMethods,
  setPaymentMethod,
}) => {
  const [open, setOpen] = useState(false);
  const { setPaymentMethod: setMethod } = useBonusesContext();
  const { push } = useHistory();
  const { search, state } = useLocation();
  const { url } = useRouteMatch();

  const currentPaymentMethodPath = `/${paymentMethod.id}`;
  const baseUrl = url.endsWith(currentPaymentMethodPath)
    ? url.slice(0, -currentPaymentMethodPath.length)
    : url;

  return (
    <div className="profile-payments__block profile-payments__deposit-block">
      <button
        className={cx('profile-payments-item__wrapper', { open })}
        onClick={() => setOpen(!open)}
        type="button"
      >
        <PaymentMethodItem paymentMethod={paymentMethod} />
        <Icon name={open ? 'arrow-up' : 'arrow-down'} />
      </button>
      {open && (
        <div className="deposit-payment-method-dropdown">
          {paymentMethods.map(paymentMethodItem => (
            <PaymentMethodItem
              className={paymentMethodItem.id === paymentMethod.id ? 'active' : ''}
              handleClick={() => {
                if (paymentMethodItem.id !== paymentMethod.id) {
                  onMethodChange?.(paymentMethodItem.name);
                }
                setMethod(paymentMethodItem);
                setPaymentMethod(paymentMethodItem);
                push({
                  pathname: `${baseUrl}/${paymentMethodItem.id}${search}`,
                  state: state,
                });
                setOpen(false);
              }}
              key={paymentMethodItem.id}
              paymentMethod={paymentMethodItem}
            />
          ))}
        </div>
      )}
    </div>
  );
};

DepositPaymentMethodsDropdown.propTypes = {
  onMethodChange: PropTypes.func,
  paymentMethod: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  paymentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ).isRequired,
  setPaymentMethod: PropTypes.func.isRequired,
};

export default DepositPaymentMethodsDropdown;
